import About from "@/components/About";
import Hero from "@/components/Hero";
import Navigation from "@/components/Navigation";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { useEffect } from "react";

export default function Home() {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const scrollToHash = () => {
      clearTimeout(timer);
      const hash = window.location.hash;
      if (!hash) return;
      timer = setTimeout(() => {
        const element = document.getElementById(hash.slice(1));
        if (element) {
          const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: offsetTop, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
          // Preserve campaign query parameters when cleaning up a section link.
          window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search);
        }
      }, 150);
    };
    scrollToHash();
    // Wouter navigation uses the History API, which does not emit hashchange.
    const events = ["hashchange", "popstate", "pushState", "replaceState"];
    events.forEach(event => window.addEventListener(event, scrollToHash));
    return () => {
      clearTimeout(timer);
      events.forEach(event => window.removeEventListener(event, scrollToHash));
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <About />
      <Services />
      <Portfolio />
      {/* <Testimonials /> */}
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
